import React from 'react';

const Features = () => {
    const features = [
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            ),
            title: "AI-Powered Customer Service",
            description: "Intelligent automation that understands and responds to customer needs with human-like precision."
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M9 12L11 14L15 10" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2"/>
                </svg>
            ),
            title: "Business Automation",
            description: "Streamline operations with intelligent workflows that adapt to your business processes."
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M22 16.92V18a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 014.11 2h1.09a2 2 0 012 1.72 12.84 12.84 0 00.7 2.81 2 2 0 01-.45 2.11L6.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45 12.84 12.84 0 002.81.7A2 2 0 0120 16.92z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            ),
            title: "Voice & Communication",
            description: "Advanced voice technology that enables natural, seamless interactions across all channels."
        },
        {
            icon: (
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
            ),
            title: "Enterprise Integration",
            description: "Secure, scalable solutions that integrate seamlessly with your existing enterprise systems."
        }
    ];

    return (
        <div style={{backgroundColor: '#222324'}} className="py-16 px-8">
            <div className="max-w-7xl mx-auto">
                <div className="text-center mb-12">
                    <h2 className="text-white mb-4 heading-2" style={{color: 'white'}}>
                        Our Focus Areas
                    </h2>
                    <p className="text-lg max-w-2xl mx-auto body-text" style={{color: '#c1c2c8', fontSize: '1.125rem'}}>
                        We specialize in cutting-edge AI solutions that transform how businesses operate and engage with their customers.
                    </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
                    {features.map((feature, index) => (
                        <div key={index} className="bg-white/5 backdrop-blur-sm rounded-xl p-6 border border-white/10 hover:bg-white/10 transition-colors">
                            <div className="w-12 h-12 rounded-lg flex items-center justify-center text-white mb-4" style={{background: 'linear-gradient(135deg, #055efd 0%, #6b21a8 100%)'}}>
                                {feature.icon}
                            </div>
                            <h3 className="text-xl font-semibold text-white mb-3 heading-3" style={{color: 'white'}}>
                                {feature.title}
                            </h3>
                            <p className="leading-relaxed body-text" style={{color: '#c1c2c8'}}>
                                {feature.description}
                            </p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Features;